"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledMediaQuery = _interopRequireDefault(require("styled-media-query"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    width: 100%; \n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Typography = _styledComponents["default"].h1.withConfig({
  displayName: "Headline__Typography",
  componentId: "sc-12v2rew-0"
})(["font-size:calc( 36px + (36 - 25.629) * ((100vw - 300px) / (1600 - 300)) );line-height:0.9;margin-bottom:0;margin-left:auto;margin-right:auto;max-width:100%;width:58rem;", ""], _styledMediaQuery["default"].lessThan('medium')(_templateObject()));

var Headline = function Headline(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(Typography, null, children);
};

Headline.propTypes = {
  children: _propTypes["default"].string.isRequired
};
var _default = Headline;
exports["default"] = _default;